import React, { useContext, useEffect } from 'react';
import WorldContinentsData from './world-continents.json';
import WorldCountriesData from './world.json';
import FundContext from '@/components/FundSingle/FundProvider';
import CountryMapping from '@/components/FundSingle/portfolio-analysis-helper/mappings/country-mapping.json';
import regions from './regions';

interface MapProps {
    data: any;
}

const Map: React.FC<MapProps> = ({data}) => {

    const { currentTabIndex, hasInitCharts } = useContext(FundContext);

    function getCountryValue(country: any) {

        var countryName = country.properties.name;

        var dataValues = data.rows;

        var countryValue = 0;

        Object.keys(dataValues).forEach((greaterRegion) => {
            Object.keys(dataValues[greaterRegion]).forEach((subRegion) => {
                if (regions[greaterRegion].includes(countryName)) {
                    countryValue = dataValues[greaterRegion].value;
                }
            });
        });

        return countryValue;

    }

    function getContinentNameByCountry(countryName: string) {
        // Find it in regions, return the key
        var continentName = '';
        Object.keys(regions).forEach((region) => {
            if (regions[region].includes(countryName)) {
                continentName = region;
            }
        });

        return continentName;
    }

    useEffect(()=>{

        function initMap() {
            // // Continent data
            // const continents = ChartGeo.topojson.feature(WorldContinentsData, WorldContinentsData.objects.continent).features;
            // var dataSet = continents.map((continent) => ({feature: continent, value: getContinentValue(continent)}));
            // var datasetLabel = 'Countries';
            // var labels = continents.map((d) => d.properties.continent);

            //Countries data
            const countries = ChartGeo.topojson.feature(WorldCountriesData, WorldCountriesData.objects.countries).features;
            var dataSet = countries.map((country) => ({feature: country, value: getCountryValue(country)}));
            var datasetLabel = 'Countries';
            var labels = countries.map((d) => getContinentNameByCountry(d.properties.name));
            
            // Create the chart
            const ctx = document.getElementById('mapChartContainer') as HTMLCanvasElement;

            if (!ctx) {
                return;
            }

            // Clear the container
            ctx.innerHTML = '';
            
            // Create canvas element for the chart
            var canvas = document.createElement('canvas');
            canvas.id = 'mapChart';
            document.getElementById('mapChartContainer').appendChild(canvas);
            
            new Chart(canvas, {
                type: 'choropleth',
                data: {
                    labels: labels,
                    datasets: [{
                        label: datasetLabel,
                        data: dataSet,
                    }]
                },
                options: {
                    showOutline: false,
                    showGraticule: false,
                    plugins: {
                        legend: {
                            display: false
                        },
                    },
                    scales: {
                        color: {
                            axis: 'x',
                            interpolate: (v) => {
                                // Apply an exponent to v to exaggerate the transition
                                const smoothV = Math.pow(v, 0.5); // You can tweak the exponent for more or less aggression

                                const r1 = 255, g1 = 255, b1 = 255;  // white
                                const r2 = 0, g2 = 1, b2 = 83;      // #001953

                                const r = r1 + (r2 - r1) * smoothV;
                                const g = g1 + (g2 - g1) * smoothV;
                                const b = b1 + (b2 - b1) * smoothV;

                                return `rgb(${Math.round(r)}, ${Math.round(g)}, ${Math.round(b)})`;
                            },
                            legend: {
                            position: 'bottom-right',
                            align: 'right',
                            },
                        },
                        projection: {
                            axis: 'x',
                            projection: 'naturalEarth1',
                            projectionScale: 1.3,
                            projectionOffset: [-50, 80],
                        },
                        x: {
                            grid: {
                                display: false,
                            },
                            ticks: {
                                display: false
                            }
                        },
                        y: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                display: false
                            }
                        },
                    }
                }
            });
        }
        
        // Wait for the chartjs script to load
        if (hasInitCharts) {
            initMap();
        } else {
            window.addEventListener('chartjsLoaded', () => {
                initMap();
            });
        }
    }, [currentTabIndex, data]);

    return (
        <div id="mapChartContainer"></div>
    );
};

export default Map;
